import { PlusInSquareIcon } from "assets/icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "ui";

import { useMarketingCampaigns } from "../../apis";
import { CampaignCards } from "../../components";

import styles from "./MarketingCampaigns.module.scss";

const MarketingCampaigns = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { campaigns, isLoading } = useMarketingCampaigns();

  return (
    <div className={styles.campaigns}>
      <div className={styles.campaigns__controls}>
        <p className={styles.campaigns__hint}>
          {t(
            "Target an audience by criteria, pick the message and the channel — the reach estimate updates live. Drafts are editable; launched campaigns are immutable."
          )}
        </p>

        <Button
          icon={<PlusInSquareIcon />}
          onClick={() => navigate("/marketing/campaigns/new")}
        >
          {t("New campaign")}
        </Button>
      </div>

      <CampaignCards campaigns={campaigns} isLoading={isLoading} />
    </div>
  );
};

export default MarketingCampaigns;
